module.exports = __webpack_public_path__ + "static/img/A172.28e174fd.jpg";